import * as Sentry from "@sentry/react";
import { StyledAnchor } from "@/components/styled-anchor";
import { PrimaryLink } from "@/components/primary-link";

type ErrorGenericProps = {
  content?: string;
  error?: unknown;
  title?: string;
};

export default function ErrorGeneric({ content, error, title }: ErrorGenericProps) {
  if (import.meta.env.PROD && error) {
    Sentry.captureException(error);
  }

  if (import.meta.env.DEV && error) {
    console.error(error);
  }

  return (
    <div className="flex items-center justify-center h-full">
      <div className="max-w-3xl mx-8 text-center flex flex-col gap-4">
        <p className="text-9xl font-black text-slate-200 animate-pulse">Oops!</p>
        <p className="text-3xl font-black text-slate-800">{title ?? "Unexpected issue"}</p>
        {content && <p className="text-slate-600">{content}</p>}
        <p className="text-slate-600">
          If you think there should definitely be an order item here,
          <br />
          please let us know in{" "}
          <StyledAnchor
            href="slack://channel?team=T0CELLC6A&id=C02Q5AFRMCZ"
            className="whitespace-nowrap"
          >
            #product-forum-help
          </StyledAnchor>
          , and we will look into it.
        </p>

        <div className="mt-8">
          <PrimaryLink to="/" size="lg">
            Go to home page
          </PrimaryLink>
        </div>
      </div>
    </div>
  );
}
